import * as types from './mutation-types'

export const fetchFormTemplates = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/finance_form_templates`, { params }).then((response) => {
            commit(types.SET_FORM_TEMPLATES, response.data.formTemplates.data)
            commit(types.SET_TOTAL_FORM_TEMPLATES, response.data.formTemplates.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchUserGuide = ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/finance_form_templates/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const searchUserGuide = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/finance_form_templates?${data}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const addFormTemplate = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/finance_form_templates', data).then((response) => {
            if (response.data.success == true){
                commit(types.ADD_FORM_TEMPLATE, response.data.formTemplate)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const statusChange = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/finance_form_templates/${data}/statusChange`).then((response) => {
            if(response.data.success){
                commit(types.UPDATE_FORM_TEMPLATE, response.data.userGuide)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateFormTemplate = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/ufinance_form_templates/${data.id}`, data).then((response) => {
            commit(types.UPDATE_FORM_TEMPLATE, response.data.userGuide)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteFormTemplate = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/api/finance_form_templates/${id}`).then((response) => {
            if (response.data.success) {
                commit(types.DELETE_FORM_TEMPLATE, id)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteMultipleFormTemplates = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/finance_form_templates/delete`, { 'ids': state.selectedFormTemplates }).then((response) => {
            commit(types.DELETE_MULTIPLE_FORM_TEMPLATES, state.selectedFormTemplates)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectAllFormTemplates = ({ commit, dispatch, state }) => {
    if (state.selectedFormTemplates.length === state.formTemplates.length) {
        commit(types.SET_SELECTED_FORM_TEMPLATES, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allItemIds = state.formTemplates.map(item => item.id)
        commit(types.SET_SELECTED_FORM_TEMPLATES, allItemIds)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}

export const selectFormTemplate = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_FORM_TEMPLATES, data)
    if (state.selectedFormTemplates.length === state.formTemplates.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}
